import { ModalComponent } from '../modal.component';
import { Component, EventEmitter, Host, HostListener, Input, OnInit, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'modal-header',
  templateUrl: './modal-header.component.html',
})
export class ModalHeaderComponent implements OnInit {
  @Input() noCloseButton = false;
  @Input() isShowEditButton: boolean;
  @Output() onEditButtonClicked = new EventEmitter<void>();

  constructor(@Host() public modal: ModalComponent) {}

  @HostListener('mousedown', ['$event']) handleMousedown(event) {
    this.modal.handleHeaderMousedown(event);
  }

  // @HostListener('document:keydown.escape', ['$event']) handleKeyboardEvent(event: KeyboardEvent) {
  //   if (!this.noCloseButton) {
  //     this.handleClose(event);
  //   }
  // }

  ngOnInit() {}

  // handlePin(event) {
  //   event.stopPropagation();
  //   this.modal.togglePin();
  // }

  handleActionMousedown(event) {
    event.stopPropagation();
  }

  handleClose(event: PointerEvent): void {
    if (event.clientX && event.clientY) {
      event.stopPropagation();
      this.modal.doClose();
    }
  }

  handleEdit(event): void {
    event.stopPropagation();
    this.onEditButtonClicked.emit();
  }
}
